module.exports = __webpack_public_path__ + "static/img/info1.5d7395b7.png";